import 'react-lazy-load-image-component/src/effects/opacity.css';
import { fallbackImg } from '../Variables';
import { useState, lazy, Suspense } from 'react';


const LazyLoadImage = lazy(() =>
  import('react-lazy-load-image-component').then(m => ({
    default: m.LazyLoadImage
  }))
);

function LazyImage({ src, alt, className, width = '', height = '', aspectRatio = 'auto' }) {

  const [error, setError] = useState(null)
  return (
    <Suspense fallback={<div>Image loading....</div>} >
      <LazyLoadImage onError={() => setError(true)} className={className} style={{ width: width, height: height, aspectRatio: aspectRatio }} alt={alt} src={error ? fallbackImg : src} effect="opacity" placeholderSrc={fallbackImg} loading='lazy' decoding="async" />
    </Suspense>
  )
}

export default LazyImage;